<template>
  <el-dialog
    :title="$t('api.csvExport.dialog.title')"
    :visible.sync="visible"
    custom-class="rwd-dialog"
    >
    <el-form
      :model="formData"
      ref="formData"
      >
      <el-row :gutter="20">
        <el-col :xs="24">
          <el-form-item
            prop="isAddBOM"
            >
            <el-checkbox
              v-model="formData.isAddBOM">
              {{ $t('api.csvExport.dialog.isAddBOM') }}
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item
            prop="isAddHeader"
            >
            <el-checkbox
              v-model="formData.isAddHeader">
              {{ $t('api.csvExport.dialog.isAddHeader') }}
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item
            prop="isConvOpt"
            >
            <el-checkbox
              v-model="formData.isConvOpt">
              {{ $t('api.csvExport.dialog.isConvOpt') }}
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <el-form-item
            prop="isForceString"
            >
            <el-checkbox
              v-model="formData.isForceString">
              {{ $t('api.csvExport.dialog.isForceString') }}
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :xs="24">
          <remote-opt
            v-model="formData.tzLocation"
            base="region"
            name="tz_location"
            prop="tzLocation"
            data="tzLocation"
            inputStore="Timezone"
            :required="true"
          >
          </remote-opt>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        @click="visible = false">
        {{ $t('api.cancelBtn') }}
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="click"
        >
        {{ $t('api.csvExport.dialog.saveBtn') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>

import { getLabelText, getOptMap } from '@/utils/i18n'
import { defCreateWithQuery } from '@/api/default'
import _ from 'lodash'

export default {
  name: 'export-dialog',
  props: {
    base: {
      type: String,
      required: true
    },
    sort: {
      type: String,
      default: ''
    },
    statusType: {
      type: String,
      default: ''
    },
    changeKey: {
      type: Function,
      default: (key) => { return key }
    },
    getListQuery: {
      type: Function,
      required: true
    },
    isBrandField: {
      type: Boolean,
      default: false
    },
    fetchFields: {
      type: Function,
      required: true
    },
    exportData: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      formValid: () => {},
      formData: {
        isAddBOM: true,
        isAddHeader: true,
        isConvOpt: true,
        isForceString: true,
        tzLocation: 'Asia/Taipei'
      },
      brandField: {},
      loading: false,
      visible: false
    }
  },
  mounted () {
    let tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (tz) {
      this.formData.tzLocation = tz
    }
  },
  methods: {
    getLabelText,
    getOptMap,
    defCreateWithQuery,
    show () {
      this.visible = true
    },
    click () {
      this.loading = true
      let q = JSON.parse(JSON.stringify(this.getListQuery()))
      q.is_add_bom = this.formData.isAddBOM ? 1 : 0
      q.is_add_header = this.formData.isAddHeader ? 1 : 0
      q.is_conv_opt = this.formData.isConvOpt ? 1 : 0
      q.is_force_string = this.formData.isForceString ? 1 : 0
      q.tz_location = this.formData.tzLocation
      if (!q.sort) {
        q.sort = 'id'
      }
      if (this.sort) {
        q.sort = this.sort
      }
      this.fetchFields().then(res => {
        if (this.isBrandField) {
          this.$store.dispatch('InitBrandField', 2).then(() => {
            this.submit(res, q, (key) => {
              return this.$store.getters.brandField[_.upperFirst(_.camelCase(key))]
            })
          })
        } else {
          this.submit(res, q, (key) => {
            return this.getOptMap(this.$t, key, this.statusType)
          })
        }
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    submit (res, q, getMap) {
      let fields = this.getFields(res.data, getMap)
      this.exportData(q, fields).then(
        res => {
          if (!res.export_path || !res.export_id) {
            this.$message({
              message: this.$t('api.csvExport.errorMsg'),
              type: 'error',
              duration: 5000
            })
            return
          }
          this.$router.push({
            path: '/chart/export/list?id=' + res.export_id
          })
        }
      ).catch(err => {
        console.log(err)
      }).then(() => {
        this.loading = false
      })
    },
    getOpts (m) {
      let opts = {}
      if (m.length > 0) {
        m.forEach(ele => {
          opts[ele.value + ''] = ele.label
        })
      }
      return opts
    },
    getFields (data, getMap) {
      let fields = {}
      for (let i = 0; i < data.length; ++i) {
        let key = data[i].name
        fields[key] = this.getLabelText(this.base, this.changeKey(key))
        let map = getMap(key)
        if (map) {
          fields[key + '.options'] = this.getOpts(map)
        }
      }
      return fields
    }
  },
  watch: {
  }
}
</script>
